import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import buttonCSS from '../Button/Button.module.scss';
import css from './ButtonLink.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var ButtonLink = function ButtonLink(props) {
  var _ref, _ref2;

  var ariaLabel = props.ariaLabel,
      big = props.big,
      bordered = props.bordered,
      box = props.box,
      borderedHover = props.borderedHover,
      borderedInverseHover = props.borderedInverseHover,
      children = props.children,
      className = props.className,
      full = props.full,
      gray = props.gray,
      href = props.href,
      medium = props.medium,
      selectActive = props.selectActive,
      small = props.small,
      targetBlank = props.targetBlank,
      white = props.white;

  if (!href) {
    return false;
  }

  var parser = document.createElement('a');
  parser.href = href;
  var active = window.location.pathname != '/' && window.location.pathname === parser.pathname;
  var attrs = Object.keys(ButtonLink.defaultProps);

  var buttonProps = _objectSpread({}, props);

  var moduleClass = cc([css.root, buttonCSS.root, className, (_ref2 = {}, _defineProperty(_ref2, css.active, (_ref = selectActive && active) !== null && _ref !== void 0 ? _ref : active), _defineProperty(_ref2, buttonCSS.big, big), _defineProperty(_ref2, css.big, big), _defineProperty(_ref2, css.box, box), _defineProperty(_ref2, buttonCSS.bordered, bordered), _defineProperty(_ref2, css.bordered, bordered), _defineProperty(_ref2, buttonCSS.borderedHover, borderedHover), _defineProperty(_ref2, css.borderedHover, borderedHover), _defineProperty(_ref2, buttonCSS.borderedInverseHover, borderedInverseHover), _defineProperty(_ref2, css.borderedInverseHover, borderedInverseHover), _defineProperty(_ref2, buttonCSS.full, full), _defineProperty(_ref2, buttonCSS.gray, gray), _defineProperty(_ref2, css.gray, gray), _defineProperty(_ref2, buttonCSS.medium, medium), _defineProperty(_ref2, css.small, small), _defineProperty(_ref2, buttonCSS.white, white), _ref2)]);
  var targetProps = targetBlank ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  attrs.forEach(function (attr) {
    delete buttonProps[attr];
  });
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread(_objectSpread({
    className: moduleClass,
    "aria-label": ariaLabel
  }, buttonProps), targetProps), {}, {
    href: href,
    children: children
  }));
};

ButtonLink.defaultProps = {
  ariaLabel: null,
  big: false,
  box: false,
  bordered: false,
  borderedHover: false,
  borderedInverseHover: false,
  className: '',
  full: false,
  gray: false,
  medium: false,
  selectActive: false,
  small: false,
  targetBlank: false,
  white: false
};
ButtonLink.propTypes = {
  ariaLabel: PropTypes.string,
  big: PropTypes.bool,
  bordered: PropTypes.bool,
  box: PropTypes.bool,
  borderedHover: PropTypes.bool,
  borderedInverseHover: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.node]).isRequired,
  full: PropTypes.bool,
  gray: PropTypes.bool,
  href: PropTypes.string.isRequired,
  medium: PropTypes.bool,
  selectActive: PropTypes.bool,
  small: PropTypes.bool,
  targetBlank: PropTypes.bool,
  white: PropTypes.bool
};
export default ButtonLink;